import { emailChangeFromHash } from '@besuites/auth/flow';
import { EMAIL_CHANGE_MARK, EMAIL_CHANGE_PATH } from '@/config/email.change.config';

let arrived: string | null = null;

let seen = false;

export const emailChangeArrival = {
    capture: (): void => {
        if (typeof window === 'undefined' || !window.location.hash.includes(EMAIL_CHANGE_MARK)) return;
        arrived = emailChangeFromHash(window.location.hash);
        seen = true;
        window.history.replaceState(window.history.state, '', EMAIL_CHANGE_PATH);
    },
    peek: (): string | null => arrived,
    seen: (): boolean => seen,
    take: (): string | null => {
        const token = arrived;
        arrived = null;
        seen = false;
        return token;
    },
};

export default emailChangeArrival;
